import { FC, ReactNode, useState } from 'react'
import { TimeAdjuster } from './components/TimeAdjuster'
import { TimeZoneSelector } from './components/TimeZoneSelector'
import { DateTime } from 'luxon'

export type TimeWidgetProps = {
  autoFocusedAdjuster: 'start' | 'end'
  dateEditing: DateTime
  displayMode?: '12' | '24'
  endAtSecondsSinceMidnight: number | null
  fieldPrefix?: string
  hideTimeZoneEditButton?: boolean
  onSubmit: (
    startAtSecondsSinceMidnight: number | null,
    endAtSecondsSinceMidnight: number | null,
    timeZone: string,
  ) => void
  renderTopRight?: () => ReactNode
  startAtSecondsSinceMidnight: number | null
  timeZone: string
  title?: string
  variant?: 'time' | 'time-and-duration'
}

/**
 * TODO - time widget tasks
 * - handle "short" input (e.g. 9h, 8 - as in 8:00 am)
 * - clean up error messaging/logic/display
 * - introduce tests to ensure edge cases are taken care of
 */
export const TimeWidget: FC<TimeWidgetProps> = ({
  autoFocusedAdjuster,
  dateEditing,
  displayMode = '12',
  endAtSecondsSinceMidnight,
  fieldPrefix,
  hideTimeZoneEditButton,
  onSubmit: submit,
  renderTopRight = () => null,
  startAtSecondsSinceMidnight,
  timeZone,
  title,
  variant = 'time-and-duration',
}) => {
  const [selectedTimeZone, setSelectedTimeZone] = useState(timeZone)
  const [showing, setShowing] = useState<
    'time-adjuster' | 'time-zone-selector'
  >('time-adjuster')

  const handleTimeZoneChange = (newTimeZone: string) => {
    setSelectedTimeZone(newTimeZone)
    setShowing('time-adjuster')
  }

  return (
    <div className="flex flex-col pt-3 pb-2 bg-white rounded cursor-default">
      {showing === 'time-adjuster' && (
        <TimeAdjuster
          autoFocusedAdjuster={autoFocusedAdjuster}
          dateEditing={dateEditing}
          displayMode={displayMode}
          endTimeSinceMidnight={endAtSecondsSinceMidnight}
          fieldPrefix={fieldPrefix}
          hideTimeZoneEditButton={hideTimeZoneEditButton}
          onSubmit={submit}
          onTimeZoneEditClick={() => setShowing('time-zone-selector')}
          renderTopRight={renderTopRight}
          startTimeSinceMidnight={startAtSecondsSinceMidnight}
          timeZone={selectedTimeZone}
          title={title}
          variant={variant}
        />
      )}
      {showing === 'time-zone-selector' && (
        <TimeZoneSelector
          dateEditing={dateEditing}
          onBack={() => setShowing('time-adjuster')}
          onTimeZoneChange={handleTimeZoneChange}
          timeZone={selectedTimeZone}
        />
      )}
    </div>
  )
}
